import { howItWorks } from "./homeData";

export function HowItWorksSection() {
  return (
    <section className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-14">
          <p className="overline mb-3">How it works</p>
          <h2 className="h-display text-3xl md:text-4xl">
            Three steps from chaos to clarity.
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-5">
          {howItWorks.map((s) => (
            <div key={s.n} className="card-soft p-7" data-testid={`how-step-${s.n}`}>
              <div className="flex items-center justify-between mb-6">
                <span className="w-12 h-12 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center">
                  <s.icon className="w-5 h-5" strokeWidth={1.8} />
                </span>
                <span className="font-mono text-xs text-navy-300 tracking-widest">{s.n}</span>
              </div>
              <h3 className="font-display text-xl text-navy-900">{s.title}</h3>
              <p className="mt-3 text-sm text-navy-600 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
